// Global toast de-duplication.
//
// Several pages fire the same toast multiple times for a single action
// (validation loops, repeated socket events, double-submit). react-toastify
// collapses toasts that share a `toastId`, so we patch the toast helpers once
// at app start to derive a stable id from the (string) message. Identical
// messages shown back-to-back are de-duplicated instead of stacking. Non-string
// content (JSX) is left untouched so rich toasts still work.
import { toast } from "react-toastify";

function contentToId(content) {
  if (typeof content !== "string" && typeof content !== "number") return undefined;
  const s = String(content);
  if (!s) return undefined;
  let h = 5381;
  for (let i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) | 0;
  return "t" + (h >>> 0);
}

const TYPES = ["success", "error", "info", "warn", "warning", "loading"];
let installed = false;

export function installToastDedup() {
  if (installed) return;
  installed = true;
  TYPES.forEach((type) => {
    const orig = toast[type];
    if (typeof orig !== "function") return;
    toast[type] = function patchedToast(content, options) {
      const opts = options ? { ...options } : {};
      if (opts.toastId == null) {
        const id = contentToId(content);
        if (id) opts.toastId = id;
      }
      return orig.call(toast, content, opts);
    };
  });
}

export default installToastDedup;
